<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">清潔及晨掃統計表</span>
        <div class="alert alert-warning" role="alert">
            1.基本(及格)分數為80分。<br>
            2.各班照片最少拍六張照片(班牌、桌椅、黑板、窗戶)，如有髒亂處請註記※，並拍照存證。<br>
            3.電燈、電扇，投影機布幕：全關→不加減分，一樣未關或歸位扣一分。<br>
            4.教室上課不列評，教室上鎖為60分，並須於備註填寫〝上鎖〞、〝上課〞(授課科目)。<br />
            5.附件請上傳 pdf 檔。
        </div>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>評分表</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Month" id="Month" label="月份" required>
                            <div is="option" v-for="o in 12" :key="o" :value="o">{{o}} 月</div>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Week" id="Week" label="週數" required>
                            <div is="option" v-for="o in 5" :key="o" :value="o">第 {{o}} 週</div>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-date-input v-model="vm.Date" id="Date" label="日期" required></form-date-input>
                    </div>
                    <div class="col-md-6 col-sm-12" v-show="false">
                        <form-input v-model="vm.RaterNo" id="RaterNo" label="評分者學號" type="text" student></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.ClassStatus" id="ClassStatus" label="教室狀態">
                            <div is="option" value=""></div>
                            <div is="option" value="上鎖">上鎖</div>
                            <div is="option" value="上課">上課</div>
                        </form-select>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.ClassID" label="班級" required>
                            <div is="option" v-for="o in classList" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                        <input type="text" class="form-control" v-model="classQuery" placeholder="篩選條件" @change="query" />
                    </div>
                    <div class="col-md-6 col-sm-12"></div>
                    <div class="col-12">
                        <form-textarea v-model="vm.Remark" id="Remark" label="備註"></form-textarea>
                    </div>
                </div>
            </b-collapse>
            <b-button class="mb-1" block v-b-toggle.accordion-2 @click="open2">評分</b-button>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <table class="table">
                    <thead>
                        <tr>
                            <th rowspan="2">項次</th>
                            <th>地面清潔</th>
                            <th>黑板清潔(板槽/板擦)</th>
                            <th>桌椅/面清潔</th>
                            <th>講桌、座椅排列</th>
                            <th rowspan="2" v-if="isInsert"></th>
                        </tr>
                        <tr>
                            <th>窗簾定位整齊</th>
                            <th>牆、天花板清潔</th>
                            <th colspan="2">電源關妥(亮燈-1，開扇-1，投影機布幕未歸位-1)</th>
                        </tr>
                    </thead>
                    <tr v-if="scoreTableData.value[0]">
                        <td rowspan="2" style="vertical-align: middle">1</td>
                        <td>{{scoreTableData.value[0].Ground}}</td>
                        <td>{{scoreTableData.value[0].Blackboard}}</td>
                        <td>{{scoreTableData.value[0].Tables}}</td>
                        <td>{{scoreTableData.value[0].Lecture}}</td>
                        <td rowspan="2" style="vertical-align: middle">
                            <b-button variant="danger" @click="scoreDel(scoreTableData.value[0].CleanScoreID)">刪除</b-button>
                        </td>
                    </tr>
                    <tr v-if="scoreTableData.value[0]">
                        <td style="border:none">{{scoreTableData.value[0].Curtain}}</td>
                        <td style="border:none">{{scoreTableData.value[0].Wall}}</td>
                        <td style="border:none">{{scoreTableData.value[0].Power}}</td>
                    </tr>
                    <tr v-if="scoreTableData.value[1]">
                        <td rowspan="2" style="vertical-align:middle">2</td>
                        <td>{{scoreTableData.value[1].Ground}}</td>
                        <td>{{scoreTableData.value[1].Blackboard}}</td>
                        <td>{{scoreTableData.value[1].Tables}}</td>
                        <td>{{scoreTableData.value[1].Lecture}}</td>
                        <td rowspan="2" style="vertical-align: middle">
                            <b-button variant="danger" @click="scoreDel(scoreTableData.value[1].CleanScoreID)">刪除</b-button>
                        </td>
                    </tr>
                    <tr v-if="scoreTableData.value[1]">
                        <td style="border:none">{{scoreTableData.value[1].Curtain}}</td>
                        <td style="border:none">{{scoreTableData.value[1].Wall}}</td>
                        <td style="border:none">{{scoreTableData.value[1].Power}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" data-th="項次"></td>
                        <td data-th="地面清潔">
                            <form-select v-model="score.Ground" id="Ground">
                                <div is="option" v-for="o in scoreN2to2" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td data-th="黑板清潔(板槽/板擦)">
                            <form-select v-model="score.Blackboard" id="Blackboard">
                                <div is="option" v-for="o in scoreN2to2" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td data-th="桌椅/面清潔">
                            <form-select v-model="score.Tables" id="Tables">
                                <div is="option" v-for="o in scoreN2to2" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td data-th="講桌、座椅排列">
                            <form-select v-model="score.Lecture" id="Lecture">
                                <div is="option" v-for="o in scoreN2to2" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td rowspan="2" style="vertical-align: middle">
                            <div class="form-group">
                                <b-button variant="primary" @click="scoreSave">儲存</b-button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td data-th="窗簾定位整齊">
                            <form-select v-model="score.Curtain" id="Curtain">
                                <div is="option" v-for="o in scoreN2to2" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td data-th="牆、天花板清潔">
                            <form-select v-model="score.Wall" id="Wall">
                                <div is="option" v-for="o in scoreN2to0" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                        <td colspan="2" data-th="電源關妥(亮燈-1，開扇-1，投影機布幕未歸位-1)">
                            <form-select v-model="score.Power" id="Power">
                                <div is="option" v-for="o in scoreN3to0" :key="o" :value="o">{{o}}</div>
                            </form-select>
                        </td>
                    </tr>
                </table>
            </b-collapse>
            <b-button class="mb-1" block v-b-toggle.accordion-3 @click="open3">附件</b-button>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        <file-upload :url="'/api/clean/File?id='+modalkey" @ok="ok"></file-upload>
                    </div>
                    <div class="col-12" v-for="f in vm.Files" :key="f">
                        <!--<img :src="Path+f" />-->
                        <a :href="Path+f" target="_blank">{{f}}</a>
                    </div>
                </div>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'cleanDetail',
        api: '/api/clean/',
        vm: {
            Ground: 0, Blackboard: 0, Tables: 0, Lecture: 0, Curtain: 0, Wall: 0, Power: 0, Files: []
        },
        data: {
            classQuery: '',
            classList: [],
            scoreTableData: { count: 0, value: [] },
            score: { CleanID: '', ClassStatus: '', Ground: 0, Blackboard: 0, Tables: 0, Lecture: 0, Curtain: 0, Wall: 0, Power: 0, Score: 0 },
            scoreN2to2: [-2, -1, 0, 1, 2],
            scoreN3to0: [-3, -2, -1, 0],
            scoreN2to0: [-2, -1, 0],
            pager: {},
        },
        computed: {
            isInsert: function () { return this.modalkey; },
            Path: function () { return this.$apiurl + this.vm.Dir },
        },
        methods: {
            load: function () {
                return this.$http({ method: 'get', url: 'api/cleanscore/Get?id='+ this.vm.CleanID, headers: this.pager })
                    .then(res => {
                        if (res.data) {
                            this.scoreTableData.count = res.data.count;
                            this.scoreTableData.value = res.data.value;
                        } else {
                            this.scoreTableData.count = 0;
                            this.scoreTableData.value = [];
                        }
                    });
            },
            reload: function () {
                this.pager.skip = 0;
                this.pager.take = 2;
                return this.load();
            },
            open2: function () {
                if (!this.isInsert) {
                    this.$bvToast.toast('請先儲存後再進行評分動作', { title: '發生錯誤', variant: 'warning', solid: true });
                } else {
                    this.reload();
                }
            },
            open3: function () {
                if (!this.isInsert) {
                    this.$bvToast.toast('請先儲存後再進行附件上傳', { title: '發生錯誤', variant: 'warning', solid: true });
                }
            },
            scoreSave: function () {
                this.score.CleanID = this.vm.CleanID;
                this.$http({ method: 'put', url: 'api/cleanscore/Put', data: this.score })
                    .then(() => {
                        this.score.Ground = 0;
                        this.score.Blackboard = 0;
                        this.score.Tables = 0;
                        this.score.Lecture = 0;
                        this.score.Curtain = 0;
                        this.score.Wall = 0;
                        this.score.Power = 0;
                        this.$bvToast.toast('新增成功', { title: '', variant: 'success', solid: true });
                        this.reload();
                    })
                    .finally(() => this.$emit('reload'));
            },
            scoreDel: function (id) {
                this.$http({ method: 'delete', url: 'api/cleanscore/Delete/' + id })
                    .then(() => {
                        this.$bvToast.toast('刪除成功', { title: '', variant: 'success', solid: true });
                        this.reload();
                    })
                    .finally(() => this.$emit('reload'));
            },
            ok: function (e) {
                this.$bvToast.toast('上傳成功', { title: '', variant: 'success', solid: true });
                if (this.vm.Files == null) {
                    this.vm.Files = [];
                }
                this.vm.Files.push(e.res.data);
            },
            query: function () { this.$parameter.class('', '', '', '', this.classQuery).then(x => this.classList = x.data.Class); }
        },
        shown: function () { this.$parameter.class().then(x => this.classList = x.data.Class); }
    });
</script>

<style>
</style>